module.exports = __webpack_public_path__ + "img/36_8.124724ee.png";